import { render, staticRenderFns } from "./TopBar.vue?vue&type=template&id=7975c42e"
var script = {}
import style0 from "./TopBar.vue?vue&type=style&index=0&id=7975c42e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports